/* eslint-disable @angular-eslint/directive-selector */
import type { OnInit } from '@angular/core';
import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { country, isEnvironmentCountry } from '../../config';
import type { Country } from '@shared/country';

@Directive({
    selector: '[ifCountry]'
})
export class IfCountryDirective implements OnInit {
    private appCountry: Country = country;
    private selectedCountries: Country | Country[] = [];
    private isHidden = true;

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {
    }

    ngOnInit(): void {
        this.updateView();
    }

    @Input()
    set ifCountry(countries: Country | Country[]) {
        this.selectedCountries = countries;
        this.updateView();
    }

    private updateView() {
        if (this.check()) {
            if (this.isHidden) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.isHidden = false;
            }
        } else {
            this.isHidden = true;
            this.viewContainer.clear();
        }
    }

    private check(): boolean {
        const selectedCountries = this.selectedCountries;
        const appCountry = this.appCountry;

        if (!selectedCountries?.length || !appCountry?.length) {
            return false;
        }

        return isEnvironmentCountry(selectedCountries);
    }
}
